<template>
  <v-btn icon class="lean-form-button-delete" @click="showDialog = true">
    <v-icon>mdi-delete</v-icon>
    <v-dialog v-model="showDialog" persistent width="300" class="lean-form-button-delete__dialog">
      <v-card class="lean-form-button-delete-dialog__card">
        <v-toolbar color="blue-grey darken-1" dark flat>
          <v-toolbar-title>{{ $t('delete.headline') }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-5">
          <p v-if="!showProgress">{{ $t('delete.text') }}</p>
          <v-progress-linear
            v-else
            stream
            background-color="blue-grey lighten-3"
            color="blue-grey"
            :value="progress"
            buffer-value="0"
            height="10"
          />
        </v-card-text>
        <v-card-actions v-if="!showProgress" class="lean-form-button-delete-dialog-card__actions pb-5">
          <v-btn @click="removeFile()">{{ $t('delete.yes') }}</v-btn>
          <v-btn @click="showDialog = false">{{ $t('delete.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-btn>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import { DatabaseAsleepError } from '@/helpers/databaseAsleepError';

export default {
  name: 'lean-form-button-delete',
  data: function () {
    return {
      showDialog: false,
      showProgress: false,
      progress: 0
    };
  },
  props: {
    model: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      language: 'selectedLanguage'
    })
  },
  methods: {
    ...mapMutations({
      setSnackbar: 'setSnackbar'
    }),
    async removeFile() {
      try {
        this.showProgress = true;
        const rootPath = `data/${this.model}/`;

        await this.removeFilesFromS3(await this.getToBeDeletedFiles(rootPath));
        // check is file deleted
        if (await this.fetch()) {
          // hide dialog
          this.progress = 100;
          await this.$router.push(`/${rootPath}`);
          this.setSnackbar({ message: 'Record remove.', type: 'success' });
        } else {
          this.setSnackbar({ message: 'something has gone wrong', type: 'error' });
        }
      } catch (e) {
        console.error(e);
        this.setSnackbar({ message: 'something has gone wrong, try it again!', type: 'error' });
      }
      this.showDialog = false;
      this.showProgress = false;
    },
    async getToBeDeletedFiles(rootPath) {
      const listObject = await this.$store.state.sdk.getAllFilesFromWorkspaceByPath(
        `${rootPath}${this.slug}/${this.language}/`
      );
      if (!listObject.Contents) {
        throw new Error(listObject);
      }
      return listObject.Contents.reduce((list, curr) => {
        if (!!curr.Key && !!curr.Size) return [...list, curr.Key];
        return list;
      }, []);
    },
    async removeFilesFromS3(pathsToBeDeleted) {
      // remove a list of files from s3
      const countFiles = pathsToBeDeleted.length;
      pathsToBeDeleted = pathsToBeDeleted.map((path) =>
        this.$store.state.sdk
          .deleteObjectFromWorkspace(path)
          .then(() => (this.progress += 100 / countFiles))
          .catch((reason) => {
            console.log('reason', reason);
          })
      );
      await Promise.all(pathsToBeDeleted);
    },
    async fetch(iteration = 1) {
      if (iteration >= 30) {
        // to much runs
        return false;
      }
      try {
        // get files from model from DB
        const records =
          (
            await this.$store.state.sdk.getDocuments({
              datatype: this.model,
              language: this.language,
              order: 'slug'
            })
          ).records || [];
        // is current slug on files from DB
        const notRemovedRecord = records.find((item) => item.slug === this.slug);
        if (notRemovedRecord) {
          const updatedIteration = iteration + 1;
          return await new Promise((resolve) => {
            setTimeout(async () => {
              resolve(this.fetch(updatedIteration));
            }, 1000);
          });
        }

        // file is remove
        return true;
      } catch (e) {
        console.error(e);
        if (e instanceof DatabaseAsleepError && iteration <= 29) {
          this.setSnackbar({ message: this.$t('database.retry', { iteration }), error: 'error' });
          const updatedIteration = iteration + 1;
          return await this.fetch(updatedIteration);
        } else if (e instanceof DatabaseAsleepError) {
          this.setSnackbar({ message: this.$t('database.failed'), error: 'error' });
        } else {
          this.setSnackbar({ message: e, error: 'error' });
        }
        return false;
      }
    }
  }
};
</script>
<style lang="scss">
.lean-form-button-delete-dialog-card__actions {
  justify-content: space-evenly;
}
</style>
